import React, { useState } from "react";
import {
	Box,
	Text,
	Grid,
	GridItem,
	Checkbox,
	Flex,
	useMediaQuery,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import {
	Link,
	useNavigate,
	useParams,
	useSearchParams,
} from "react-router-dom";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
	RenderTextField,
	DarkButton,
	yupEmail,
	yupPassword,
	type AppDispatch,
	setPageLoading,
	loginSupplier,
	frappeMethodService,
	get_doc,
	USERID_FETCH_SUCCESS,
	SET_MESSAGE,
	ERROR_MSG,
	formatErrorMessage,
	SUCCESS_MSG,
} from "@karkhanaui/react";
import { Mixpanel } from "../../Mixpanel.js";
export const Login: React.FC<any> = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const SO_UUID = searchParams.get("po");
	const uuid = searchParams.get("rfq");
	const [isMobileTablet] = useMediaQuery("(max-width: 768px)");

	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const [rememberMe, setRememberMe] = useState<boolean>(false);
	const basicValidation = Yup.object().shape({
		userName: yupEmail,
		password: yupPassword,
	});

	const onSubmit = async (event: any) => {
		dispatch(
			setPageLoading({
				loading: true,
				loadingText: "Logging you in...",
			})
		);
		try {
			const result: any = await dispatch(
				loginSupplier(
					event.userName,
					event.password,
					uuid != null ? uuid : "",
					SO_UUID !== null ? SO_UUID : ""
				)
			);
			if (result.status === 200) {
				navigate("/home");
				const uniqueUserId: any = await get_doc({
					doc: "User ID",
					fields: ["id"],
					filters: [["name", "=", event.userName]],
				});
				if (uniqueUserId?.status === 200) {
					dispatch({
						type: USERID_FETCH_SUCCESS,
						payload: { uniqueUserId: uniqueUserId?.data.data[0]?.id },
					});
					window.dataLayer?.push({
						event: "User Login",
						user_id: uniqueUserId?.data.data[0]?.id,
						user_email: event.userName,
						page_url: window.location.href,
						page_name: window.location.pathname,
						success: true,
					});
					Mixpanel.track("login", {
						event: "User Login",
						user_id: uniqueUserId?.data.data[0]?.id,
						user_email: event.userName,
						page_url: window.location.href,
						page_name: window.location.pathname,
						success: true,
					});
				}
				dispatch(
					setPageLoading({
						loading: false,
						loadingText: "",
					})
				);
				dispatch({
					type: SET_MESSAGE,
					payload: {
						case: SUCCESS_MSG,
						data: "Logged in",
					},
				});

				navigate("/home");
			}
		} catch (error) {
			window.dataLayer?.push({
				event: "User Login",
				user_email: event.userName,
				page_url: window.location.href,
				page_name: window.location.pathname,
				success: false,
			});
			Mixpanel.track("loginFailed", {
				event: "User Login",
				user_email: event.userName,
				page_url: window.location.href,
				page_name: window.location.pathname,
				success: false,
			});
			dispatch(
				setPageLoading({
					loading: false,
					loadingText: "",
				})
			);
			dispatch({
				type: SET_MESSAGE,
				payload: {
					case: ERROR_MSG,
					data: formatErrorMessage(error),
				},
			});
		}
	};

	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			flexDirection="column"
			h="100%"
			bg={{
				base: "linear-gradient(175.96deg, #379179 -188.68%, #79C4B0 114.46%)",
				lg: "#fff",
			}}
		>
			<Box
				display="flex"
				flexDir="column"
				h={{ base: "100%", lg: "auto" }}
				w={{ base: "100%", lg: "auto" }}
				mt={{ base: "2rem", lg: "0" }}
			>
				<Flex
					mb="1.5rem"
					flexDirection="column"
					justifyContent="center"
					px={{ base: "1rem", lg: 0 }}
				>
					<Text
						textStyle="primary.poster"
						color={!isMobileTablet ? "#000" : "#fff"}
					>
						Login
					</Text>
					<Text
						textStyle="primary.text"
						color={!isMobileTablet ? "#000" : "#fff"}
					>
						Welcome back!
					</Text>
				</Flex>

				<Box
					borderRadius={{ base: "1rem 1rem 0 0", lg: "none" }}
					bg="#fff"
					flexGrow={1}
					pt={{ base: "2rem", lg: "0" }}
				>
					<Formik
						initialValues={{ userName: "", password: "", remember: false }}
						validationSchema={basicValidation}
						onSubmit={onSubmit}
					>
						{(formik) => {
							return (
								<Form id="signinsupplier" className="suppliersignin">
									<Grid templateColumns={{ xs: "repeat(1,1fr)" }} gap={5}>
										<GridItem px={{ base: "1rem", lg: 0 }}>
											<RenderTextField
												label="Email ID"
												name="userName"
												type="email"
												placeholder="Enter Email Address"
												isMandatory={true}
											/>
										</GridItem>
										<GridItem px={{ base: "1rem", lg: 0 }}>
											<RenderTextField
												label="Password"
												name="password"
												type="password"
												placeholder="********"
												isMandatory={true}
											/>
											<Flex
												justifyContent="space-between"
												mt={{ base: 6, lg: 1 }}
											>
												<Box
													display="flex"
													justifyContent="center"
													alignItems="center"
												>
													<Checkbox
														isChecked={rememberMe}
														onChange={() => {
															setRememberMe((prevState) => !rememberMe);
														}}
														colorScheme="green"
													>
														<Text textStyle="primary.text">Remember me</Text>
													</Checkbox>
												</Box>
												<Link
													to={`/forgotPassword${
														uuid != null ? `/?rfq=${uuid}` : ""
													}${SO_UUID != null ? `/?po=${SO_UUID}` : ""}`}
												>
													<Text
														_hover={{ textDecoration: "underline" }}
														textStyle="primary.secondaryText"
													>
														Forgot password?
													</Text>
												</Link>
											</Flex>
										</GridItem>
										<GridItem
											display="flex"
											justifyContent="center"
											alignItems="center"
											mt={{ base: "1rem", lg: "3.375rem" }}
											px={{ base: "1rem", lg: 0 }}
										>
											<DarkButton
												id="supplier_user_login_btn"
												type="submit"
												className="suppliersignin"
												width={{ base: "100%", lg: "23.75rem" }}
												height="50px"
												children="Log In"
												bg="#4BA18A"
												_hover={{ bg: "#38846D" }}
											/>
										</GridItem>
										<GridItem px={{ base: "1rem", lg: 0 }}>
											<Box
												display="flex"
												justifyContent={{ base: "center", lg: "left" }}
											>
												<Text textStyle="primary.secondaryText">
													Don't have an account?
												</Text>
												<Text
													textStyle="primary.bold"
													sx={{ fontWeight: "600" }}
													as={Link}
													to={`/register${
														uuid != null
															? `/?rfq=${uuid}`
															: SO_UUID != null
															? `/?po=${SO_UUID}`
															: ""
													}`}
													color={isMobileTablet ? "#4BA18A" : ""}
												>
													&nbsp;
													<span style={{ color: "#4BA18A" }}>Sign Up</span>
												</Text>
											</Box>
										</GridItem>
									</Grid>
								</Form>
							);
						}}
					</Formik>
				</Box>
			</Box>
		</Box>
	);
};

export default Login;
